import axios from 'axios';
import { push } from 'connected-react-router';
import { Action, Reducer } from 'redux';
import { reset } from 'redux-form';
import { AppThunkAction } from '../';
import { errorHandling } from '../../helper/ErrorHandling';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import Moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { email } from '../../helper/formvalidation';
import { Stream } from 'stream';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import React, { ReactFragment } from 'react';
import { dateUTCFormat, dateFormat } from '../../helper/formvalidation';
import { actionCreators as _NavDefault } from '../../store/menu/NavDefault';

const urlParams = new URLSearchParams(window.location.search);
const childid = urlParams.get('childid');
const childname = urlParams.get('childname');

export interface SubscriptionState {
    isLoading: boolean;
    planlists: PlanList[];
    freqlists: PlanList[];
    sublists: SubList[];
    subscriptionplan: any;
}

export interface SubList {
    id?: string;
    memberShipEnrollmentId?: string;
    paymentRefId: string;
    name: string;    
    frequency: string;    
    frequencyValue: string;
    enrolledOn: string;
    paidDate: string;
    amount: string;
    paymentStatus: string;
    description: string;
    statusId: any;
    trialDays: any;
    trialDescription: string;
    expirationDate: string;
    nextPaymentDate: string;
    patientId?: string;
}
export interface PlanList {
    id: string;
    accountId: string;
    code: string;
    name: string;
    description: string;
    extRefId: string;
    frequency: string;
    recordTypeId: string;
    recordId: string;
    frequencyId: string;
    frequencyValue: string;
    statusId: any;
    quantity: any;
    price: any;
    trialDays: any;
    shortDescription: string;
}


export interface RequestSubscription {
    type: 'REQUEST_PLAN_LIST';
    planlists: PlanList[];
    sublists: SubList[];
    subscriptionplan: any;
    freqlists: PlanList[];
}

export interface ReceiveSubscription {
    type: 'RECEIVE_PLAN_LIST';
    planlists: PlanList[];
    sublists: SubList[];
    subscriptionplan: any;
    freqlists: PlanList[];
}


export type KnownAction = RequestSubscription | ReceiveSubscription;

export const actionCreators = {
    getPlanList: (): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {

            var accountid: any = localStorage.getItem("AccountId");
            axios.get('/subscription/getPlanList/' + accountid)
                .then(function (response) {
                    const result = response.data;
                    const uniqueUsers = result.filter(
                        (user: any, index: any, self: any) =>
                            index === self.findIndex((u: any) => u.frequency === user.frequency)
                    );

                    if (uniqueUsers.length > 0)
                        dispatch(actionCreators.getActivePlanList(uniqueUsers[0].frequency));
                    const result1 = result.filter((s: any) => s.frequency == uniqueUsers[0].frequency);

                    localStorage.setItem("PlanId", localStorage.getItem('PlanId')|| "");
                    dispatch({ type: 'RECEIVE_PLAN_LIST', planlists: result1, freqlists: uniqueUsers });
                })
                .catch(function (error) {

                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PLAN_LIST' });
        }
    },
    getActivePlanList: (frequency: any): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {

            var accountid: any = localStorage.getItem("AccountId");
            axios.get('/subscription/getPlanList/' + accountid)
                .then(function (response) {
                    const result = response.data;
                    const result1 = result.filter((s: any) => s.frequency == frequency);
                    const uniqueUsers = result.filter(
                        (user: any, index: any, self: any) =>
                            index === self.findIndex((u: any) => u.frequency === user.frequency)
                    );
                    localStorage.setItem("Frequency", frequency);
                    dispatch({ type: 'RECEIVE_PLAN_LIST', planlists: result1, freqlists: uniqueUsers });
                })
                .catch(function (error) {

                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PLAN_LIST' });
        }
    },
    getSubscriptionList: (): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {
            var patientLocalStroage: any = localStorage.getItem('Patient');
            var patientdata = JSON.parse(patientLocalStroage);
            var memberid = patientdata.memberId;
            axios.get('/subscription/getSubscriptionList/' + memberid)
                .then(function (response) {
                    const result = response.data;
                    dispatch({ type: 'RECEIVE_PLAN_LIST', sublists: result });
                })
                .catch(function (error) {

                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PLAN_LIST' });
        }
    },
   
    getsubscriptionPlanList: (typeid: any): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {
            var patientLocalStroage: any = localStorage.getItem('Patient');
            var serviceid: any = localStorage.getItem('serviceid');
            var patientstore: any = JSON.parse(patientLocalStroage);
            var memberid: any = patientstore.memberId;
            var plan: any = localStorage.getItem('SubscriptionPlan');
            var planstore: any = JSON.parse(plan);
            if (localStorage.getItem('PlanId'))
                var planid: any = localStorage.getItem('PlanId');
            else
                var planid: any = planstore.id;
            axios.get('/subscription/getsubscriptionPlanList/' + memberid + "/" + planid + "/" + serviceid + "/" + typeid)
                .then(function (response) {
                    const result = response.data;
                    if (typeid == 2) {
                        dispatch(actionCreators._requestScheduleUpdate("4"));
                    }
                    else
                        dispatch(actionCreators.SubscriptionPlanSave("1"));


                })
                .catch(function (error) {
                    if (error.response.data.statusCode == 400) {
                        var errorObject = JSON.parse(error.response.data.errorMessage);
                        if (errorObject.ModelState != undefined) {
                            toastr.error('', errorObject.ModelState[""][0]);
                        }
                        else if (errorObject.Message == "The selected plan is not eligible for the requested appointment") {
                            return toastr.error('', 'The selected plan is not eligible for the requested appointment');

                        }
                        else if (errorObject.Message == "You have utilized all benefits for the selected plan") {
                            toastr.error('', 'You have utilized all benefits for the selected plan');

                            dispatch(actionCreators.requestScheduleUpdate("2"));


                        }
                    }
                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PLAN_LIST' });
        }
    },
    getselectedsubscriptionList: (): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {
            var patientLocalStroage: any = localStorage.getItem('Patient');
            var serviceid: any = localStorage.getItem('serviceid');
            var patientstore: any = JSON.parse(patientLocalStroage);
            var memberid: any = patientstore.memberId;

            axios.get('/subscription/getselectedsubscriptionList/' + memberid + "/" + serviceid)
                .then(function (response) {
                    const result = response.data;
                    localStorage.setItem("PlanId", result);

                })
                .catch(function (error) {

                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PLAN_LIST' });
        }
    },
    subscriptionplanlist: (): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (appState) {
            const urlParams = new URLSearchParams(window.location.search);
            const appointmentid = urlParams.get('appointmentid');
            const doctorid = urlParams.get('doctorid');
            const email = urlParams.get('email');
            const name = urlParams.get('name');
            const methodid = urlParams.get('methodid');
            const trialdays = urlParams.get('trialdays');
            dispatch(push("/subscriptionlist?doctorid=" + doctorid + "&appointmentid=" + appointmentid + "&name=" + name + "&email=" + email + "&methodid=" + methodid + "&childid=" + childid + "&childname=" + childname))

        }
    },
    SubscriptionPlanSave: (type: any): AppThunkAction<KnownAction> => (dispatch: any, getState: any) => {
        const appState = getState();
        if (appState && appState.paymentProcess) {
            const urlParams = new URLSearchParams(window.location.search);
            const appointmentid = urlParams.get('appointmentid');
            const doctorid = urlParams.get('doctorid');
            const email = urlParams.get('email');
            const name = urlParams.get('name');
            const methodid = urlParams.get('methodid');
            var patientLocalStroage: any = localStorage.getItem('Patient');
            var patientstore: any = JSON.parse(patientLocalStroage);
            var accountid: any = localStorage.getItem('AccountId');
            var plan: any = localStorage.getItem('SubscriptionPlan');
            var planstore: any = JSON.parse(plan);
            if (localStorage.getItem('PlanId'))
                var planid: any = localStorage.getItem('PlanId');
            else
                var planid: any = planstore.id;
            var paymethodid: any = 4;
            var data: any = {
                AccountId: accountid,
                MemberId: patientstore.memberId,
                PatientId: patientstore.id,
                EncounterId: appointmentid,
                PlanId: planid,
                StatusId: 3,
            }
            axios.post('subscription', data)
                .then(function (response) {
                    localStorage.setItem("MemberPlanId", response.data);
                    if (paymethodid == "4" && plan != null) {
                        dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                        dispatch(push("/paymentprocess/" + doctorid + "/" + appointmentid + "/" + name + "/" + email + "/" + planstore.extRefId + "/" + planstore.trialDays ));
                    }
                    else if (type == "2") {
                        dispatch(actionCreators.requestScheduleUpdate("2"));

                    }
                    else {
                        dispatch(actionCreators._requestScheduleUpdate("4"));
                    }
                })
                .catch(function (error) {
                    dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                    var errorObject = JSON.parse(error.response.data.errorMessage);
                    if (errorObject.Message == "No Changes") {
                        if (paymethodid == "4" && plan != null) {
                            dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                            dispatch(push("/paymentprocess/" + doctorid + "/" + appointmentid + "/" + name + "/" + email + "/" + planstore.extRefId + "/" + planstore.trialDays));
                        }
                        else if (type == "2") {
                            dispatch(actionCreators.requestScheduleUpdate("2"));

                        }
                        else {
                            dispatch(actionCreators._requestScheduleUpdate("4"));
                        }

                    } else {
                        errorHandling(error.response.data.statusCode);
                    }
                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PAY_METHOD', isPayLoading: true });
        }
    },
    requestScheduleUpdate: (paymethodid: any): AppThunkAction<KnownAction> => (dispatch: any, getState: any) => {
        const appState = getState();
        if (appState && appState.paymentProcess) {
            const urlParams = new URLSearchParams(window.location.search);
            const appointmentid = urlParams.get('appointmentid');
            const doctorid = urlParams.get('doctorid');
            const email = urlParams.get('email');
            const name = urlParams.get('name');
            const methodid = urlParams.get('methodid');
            const trialdays = urlParams.get('trialdays');
            var data: any = {
                Id: appointmentid,
                PayMethodId: paymethodid
            }
            axios.post('/appointment/ScheduleUpdate', data)
                .then(function (response) {
                    if (paymethodid == "1") {
                        dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                        dispatch(push("/insurancelist?doctorid=" + doctorid + "&appointmentid=" + appointmentid + "&name=" + name + "&email=" + email + "&methodid=" + methodid + "&childid=" + childid + "&childname=" + childname))
                    } else if (paymethodid == "2") {
                        dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                        dispatch(push("/paymentprocess/" + doctorid + "/" + appointmentid + "/" + name + "/" + email + "/" + null + "/" + null));
                    } else if (paymethodid == "4") {
                        dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                        dispatch(push("/subscriptionlist?doctorid=" + doctorid + "&appointmentid=" + appointmentid + "&name=" + name + "&email=" + email + "&methodid=" + methodid + "&childid=" + childid + "&childname=" + childname))
                    } else {
                        dispatch({ type: 'RECEIVE_PAY_METHOD' });
                        return;
                    }
                })
                .catch(function (error) {
                    dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                    var errorObject = JSON.parse(error.response.data.errorMessage);
                    if (errorObject.Message == "No Changes") {
                        if (paymethodid == "1") {
                            dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                            dispatch(push("/insurancelist?doctorid=" + doctorid + "&appointmentid=" + appointmentid + "&name=" + name + "&email=" + email + "&methodid=" + methodid + "&childid=" + childid + "&childname=" + childname))
                        } else if (paymethodid == "2") {
                            dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                            dispatch(push("/paymentprocess/" + doctorid + "/" + appointmentid + "/" + name + "/" + email + "/" + null + "/" + null));
                        } else if (paymethodid == "4") {
                            dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                            dispatch(push("/subscriptionlist?doctorid=" + doctorid + "&appointmentid=" + appointmentid + "&name=" + name + "&email=" + email + "&methodid=" + methodid + "&childid=" + childid + "&childname=" + childname))
                        }
                        else {
                            dispatch({ type: 'RECEIVE_PAY_METHOD' });
                            return;
                        }
                    } else {
                        errorHandling(error.response.data.statusCode);
                    }
                })
                .then(function () {
                });
            dispatch({ type: 'REQUEST_PAY_METHOD', isPayLoading: true });
        }
    },
    _requestScheduleUpdate: (paymethodid: any): AppThunkAction<KnownAction> => (dispatch: any, getState: any) => {
        const appState = getState();
        if (appState && appState.paymentProcess) {
            const urlParams = new URLSearchParams(window.location.search);
            const appointmentid = urlParams.get('appointmentid');
            const methodid = urlParams.get('methodid');
            var autoapprovel: any = appState.account.Settings.filter((se: any) => se.name == "Appointment Auto Approval")[0];
            var autoproviderselect: any = appState.account.Settings.filter((se: any) => se.name == "Auto Provider Selection in PickaProvider")[0];
            var statusid: any = "";
            if (autoproviderselect.customizeValue == "No") {
                if (methodid == "2" || methodid == "1") {
                    statusid = "9"
                }
            } else {
                if (autoapprovel.customizeValue == "Yes") {
                    if (methodid == "3") {
                        statusid = "9"
                    } else {
                        statusid = "1"
                    }
                } else {
                    statusid = "9"
                }
            }
            var planid: any = localStorage.getItem('PlanId');
            var data: any = {
                Id: appointmentid,
                StatusId: statusid,
                PayMethodId: paymethodid,
                PlanId: planid
            }
            axios.post('/appointment/ScheduleUpdate', data)
                .then(function (response) {
                    dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                    dispatch(push("/success/" + appointmentid))
                })
                .catch(function (error) {
                    dispatch({ type: 'RECEIVE_PAY_METHOD', isPayLoading: false });
                    var errorObject = JSON.parse(error.response.data.errorMessage);
                    if (errorObject.Message == "No Changes") {
                        dispatch(push("/success/" + appointmentid))
                    } else {
                        errorHandling(error.response.data.statusCode);
                    }
                })
                .then(function () {
                });
        }
        dispatch({ type: 'REQUEST_PAY_METHOD', isPayLoading: true });
    },

    cancelSubscription: (subscriptionId: string, patientId: string, Id: string, reason: string): AppThunkAction<KnownAction> => (dispatch: any, getState) => {
        const appState = getState();
        if (subscriptionId != null) {
            const currentDate = new Date();
            const canceledOn = currentDate.toISOString();

            const data = {
                Id: Id,               
                PatientId: patientId,               
                subscriptionId: subscriptionId,               
                canceledOn: canceledOn,
                statusId: 3,
                cancelReason: reason
            };

            axios.post('/subscription/CancelSubscription', data)
                .then(function (response) {
                    toastr.success('', 'Subscription cancelled successfully');                    
                    dispatch(actionCreators.getSubscriptionList());
                })
                .catch(function (error) {                   
                    toastr.error('', 'Failed to cancel subscription. Please try again');
                    console.error('Cancel subscription error:', error);
                });
        }
    },
};


const PaymentUnloadedState: SubscriptionState = {
    planlists: [],
    sublists: [],
    freqlists: [],
    subscriptionplan: "",
    isLoading: false
};


export const reducer: Reducer<SubscriptionState> = (state: SubscriptionState | undefined, incomingAction: Action): SubscriptionState => {
    if (state === undefined) {
        return PaymentUnloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_PLAN_LIST':
            return {
                planlists: state.planlists,
                freqlists: state.freqlists,
                sublists: state.sublists,
                isLoading: true,
                subscriptionplan: state.subscriptionplan
            };
        case 'RECEIVE_PLAN_LIST':
            return {
                planlists: action.planlists,
                freqlists: action.freqlists,
                sublists: action.sublists,
                subscriptionplan: action.subscriptionplan,
                isLoading: false
            };
        default:
            return state;
    }
};


// Adds trialDays to a start date and returns the end date


// Formats a Date object as YYYY-MM-DD (or use toLocaleDateString for local format)
export function formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
    // Or: return date.toLocaleDateString();
    }
